// React Imports
import * as React from 'react';
import {useDispatch} from "react-redux";

// Mui Imports
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {Stack} from "@mui/material";
import {changeWorkQueue} from "../../WorkQueue/workQueueSlice";
import {changeWorkIssuance} from "../workIssuanceSlice";

// App Imports



// main function
export default function IssuanceMethodTabs(props) {
    const [methodTabValue, setMethodTabValue] = React.useState(1);

    const dispatchData = useDispatch();


    const handleChange = (event, newValue) => {
        setMethodTabValue(newValue);
        dispatchData(changeWorkIssuance({id: 0 }));
        dispatchData(changeWorkQueue({propertyDropdownTitleId: 0 }));
        console.log("propertyDropdownTitleId modified to equal 0 ");
        if(newValue == 0){
            dispatchData(changeWorkIssuance({showStats: true,
                owedGridState: false,
                obligationGridState: false,
                offsetsGridState: false,
                paymentGridState: false,
                fringeGridState: false,
                taxGridState: false,
                expenseGridState: false,
                requestGridState: false}));
            console.log("show cdp hierarchy");
        }
        if(newValue == 1){
            dispatchData(changeWorkIssuance({showStats: false, owedGridState: true}));
            console.log("show issuance grid");
        }
        if(newValue == 2){
            dispatchData(changeWorkIssuance({
                id: null,
                idFrom: null,
                idTo: null,
                contractType: null,
                mcode: null,
                name: null,
                craatedOn: null,
                createdFrom: null,
                createdTo: null,
                contractSearchGridRefresh: false
            }));
            dispatchData(changeWorkIssuance({methodTabsState: true, propertySearchState: false, unstructuredSearchState: true,statsViewState: false}));
            console.log("show unstructured search");
        }

    };

    return (
        <Stack direction="row" spacing={2}>

            <Box sx={{pt: 2,  width: 400, height: 40, bgcolor: 'background.paper' }}>
                <Tabs value={methodTabValue}
                      defaultValue={1}
                      onChange={handleChange} >
                    <Tab  label="Hierarchy" title="View by product groupings"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                    <Tab  label="By Property" title="View by property"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                    <Tab  label="Unstructured" title="Find specific contract"
                          sx={{
                              mx: 4,
                              fontSize: '1.2rem',
                              fontWeight: 500,
                              // textTransform: 'none'   // optional: prevents ALL CAPS
                          }}/>
                </Tabs>
            </Box>
        </Stack>
    );
}
